import { createContext, ReactNode, useContext, useMemo, useState } from "react";

type EntityChatFilterContextValue = {
  selectedEntityIds: string[] | null;
  selectedSeasons: string[] | null;
  isUnreadOnly: boolean;
  isPendingActionOnly: boolean;
  setSelectedEntityIds: (entityIds: string[] | null) => void;
  setSelectedSeasons: (seasons: string[] | null) => void;
  setUnreadOnly: (isOn: boolean) => void;
  setPendingActionOnly: (isOn: boolean) => void;
};

const EntityChatFilterContext = createContext<EntityChatFilterContextValue>({
  selectedEntityIds: null,
  selectedSeasons: null,
  isUnreadOnly: false,
  isPendingActionOnly: false,
  setSelectedEntityIds: () => {},
  setSelectedSeasons: () => {},
  setUnreadOnly: () => {},
  setPendingActionOnly: () => {},
});

export const EntityChatFilterProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [selectedEntityIds, setSelectedEntityIds] = useState<string[] | null>(
    null
  );
  const [selectedSeasons, setSelectedSeasons] = useState<string[] | null>(null);
  const [isUnreadOnly, setIsUnreadOnly] = useState(false);
  const [isPendingActionOnly, setIsPendingActionOnly] = useState(false);

  const value = useMemo(
    () => ({
      selectedEntityIds,
      selectedSeasons,
      isUnreadOnly,
      isPendingActionOnly,
      setSelectedEntityIds,
      setSelectedSeasons,
      setUnreadOnly: setIsUnreadOnly,
      setPendingActionOnly: setIsPendingActionOnly,
    }),
    [selectedEntityIds, selectedSeasons, isUnreadOnly, isPendingActionOnly]
  );

  return (
    <EntityChatFilterContext.Provider value={value}>
      {children}
    </EntityChatFilterContext.Provider>
  );
};

export const useEntityChatFilter = (): EntityChatFilterContextValue =>
  useContext(EntityChatFilterContext);
